export default {
  state: {
    processing: false,
    error: null,
    scrollValue: 0
  },
  mutations: {
    SET_PROCESSING(state, payload){
      state.processing = payload
    },
    SET_ERROR(state, payload){
      state.error = payload
    },
    CLEAR_ERROR(state){
      state.error = null
    },
    SET_SCROLL_VALUE(state, payload){
      state.scrollValue = payload
    },
  },
  actions: {
    GET_SCROLL({commit}) {
      let scrollVal = 0;
      window.addEventListener('scroll', function() {
        scrollVal = pageYOffset;
        commit('SET_SCROLL_VALUE', scrollVal);
      });
      
    }
  },
  getters: {
    getProcessing: (state) => state.processing,
    getError: (state) => state.error,
    getScroll: (state) => state.scrollValue,
  }
}